export enum UserPermissionEnum {
  UserRead = 'user_read', // Доступ на просмотр списка всех пользователей пула
  UserManage = 'user_manage', // Создание/редактирование/удаление пользователей
  UserPersonalDataRead = 'user_personal_data_read', // Просмотр личных данных пользователей
  UserBlock = 'user_block', // Возможность заблокировать пользователя из админ панели
  UserRoleAssign = 'user_role_assign', // Возможность устанавливать роли пользователю
  UserCommissionUpdate = 'user_commission_update', // Возможность обновления комиссий пользователя
  UserReferralRewardUpdate = 'user_referral_reward_update', // Возможность обновления реф. вознаграждения пользователя
  UserGaReset = 'user_ga_reset', // Сброс GA для пользователей
  UserSendEmailConfirmationLink = 'user_send_email_confirmation_link', // Подтверждение email
  UserSendPasswordResetLink = 'user_send_password_reset_link', // Сброс пароля
  TemporaryObserverLinkManage = 'temporary_observer_link_manage', // Создание временных ссылок наблюдателя

  PoolCommissionRead = 'pool_commission_read', // Просмотр раздела "Управление комиссиями"
  PoolCommissionUpdate = 'pool_commission_update', // Установка комиссий пула и на вывод средств
  PoolLowCommissionUpdate = 'pool_low_commission_update', // Установка низких комиссий пула

  MinWithdrawalAmountRead = 'min_withdrawal_amount_read', // Просмотр раздела "Управление лимитами вывода"
  MinWithdrawalAmountUpdate = 'min_withdrawal_amount_update', // Установка мин суммы вывода с пула

  WithdrawalRequestRead = 'withdrawal_request_read', // Просмотр раздела "Запросы на вывод"
  WithdrawalRequestApprove = 'withdrawal_request_approve', // Возможность управлять запросами на вывод

  RoleRead = 'role_read', // Просмотр списка ролей
  RoleManage = 'role_manage', // Создание/редактирование/удаление ролей

  PortalGlobalNotificationManage = 'portal-global-notification-manage', // Просмотр и управление системными оповещениями
}
